// @flow
import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';
import castMiddleware from './cast/middleware';
import watchlistMiddleware from './watchlist/middleware';
import vmAnalyticsMiddleware from './analytics/vmanalytics/middleware';
import configureDeps from './configureDeps';
import configureEpics from './configureEpics';
import isClient from './app/isClient';
import isReactNative, { hasReactNativeRemoteJSDev } from './app/isReactNative';

// Like redux-thunk, but with just one argument for dependencies.
const injectMiddleware = deps => ({ dispatch, getState }: any) => (next: any) => (action: any) => {
  if (typeof action === 'function') {
    return action({ ...deps, dispatch, getState, config: getState().config });
  }
  return next(action);
};

const configureMiddleware = (initialState: any, platformDeps: any, platformMiddleware: any) => {
  const deps = configureDeps(initialState, platformDeps);
  const rootEpic = configureEpics(deps);
  const epicMiddleware = createEpicMiddleware(rootEpic);

  const middleware = [
    injectMiddleware(deps),
    epicMiddleware,
    ...platformMiddleware,
    vmAnalyticsMiddleware,
    watchlistMiddleware,
  ];

  const enableLogger =
    initialState.config.base.env === 'development' &&
    isClient &&
    (!isReactNative || hasReactNativeRemoteJSDev);

  // Logger must be the last middleware in chain.
  if (enableLogger) {
    const logger = createLogger({
      collapsed: true,
    });
    // THIS WILL CRASH THE APP WHEN YOU RUN IT WITH SENTRY
    middleware.push(logger);
  }

  /* Chromecast middleware is common for all platforms (except TV and Chromecast itself) */
  if (!process.env.IN_CHROMECAST_MODE) {
    middleware.push(castMiddleware);
  }

  if (module.hot && typeof module.hot.accept === 'function') {
    if (isReactNative) {
      module.hot.accept(() => {
        const configureEpics = require('./configureEpics').default;

        epicMiddleware.replaceEpic(configureEpics(deps));
      });
    } else {
      module.hot.accept('./configureEpics', () => {
        const configureEpics = require('./configureEpics').default;

        epicMiddleware.replaceEpic(configureEpics(deps));
      });
    }
  }

  return middleware;
};

export default configureMiddleware;
